import React from 'react';

const modalTitles = {
  terms: 'Terms of Service',
  privacy: 'Privacy Policy',
  cookie: 'Cookie Policy',
};

const LegalModal = ({ modalOpen, modalType, closeModal, termsHTML, privacyNoticeHTML, cookieHTML, overlayClassName = 'bg-gray-500 bg-opacity-75', contentClassName = 'privacy-content text-gray-700 overflow-y-auto max-h-[60vh]' }) => {
  if (!modalOpen) {
    return null;
  }

  const modalContent = modalType === 'terms'
    ? termsHTML
    : modalType === 'privacy'
      ? privacyNoticeHTML
      : cookieHTML;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
        <div
          className={`fixed inset-0 transition-opacity ${overlayClassName}`}
          onClick={closeModal}
        ></div>
        <div className="relative inline-block w-full max-w-2xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white rounded-2xl shadow-xl">
          <div className="flex justify-between items-start mb-6">
            <div>
              <h3 className="text-2xl font-bold text-gray-900">{modalTitles[modalType]}</h3>
              <p className="text-sm text-gray-500 mt-1">Last updated: February 2026</p>
            </div>
            <button
              onClick={closeModal}
              className="text-gray-400 hover:text-gray-600 text-2xl"
            >
              &times;
            </button>
          </div>
          <div className="prose max-w-none">
            <div
              className={contentClassName}
              dangerouslySetInnerHTML={{ __html: modalContent }}
            />
          </div>
          <div className="mt-8 flex justify-end">
            <button
              onClick={closeModal}
              className="px-6 py-3 bg-navy-900 text-white font-medium rounded-lg hover:bg-navy-800 transition focus:outline-none focus:ring-2 focus:ring-navy-300 focus:ring-offset-2"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
